import {makeReactContext} from 'lib/makeReactContext';

const UNSET_FLOWCHART_CLIENT_ID = 'UNSET_FLOWCHART_CLIENT_ID';

interface ProcessFlowchartContext {
  hideTooltips: boolean;
  flowchartClientId: string;
}

const ProcessFlowchartContext = makeReactContext<ProcessFlowchartContext>(
  () => ({
    hideTooltips: false,
    flowchartClientId: UNSET_FLOWCHART_CLIENT_ID,
  }),
  'ProcessFlowchartContext'
);

export default ProcessFlowchartContext;
